<template>
  <div class="offline-pay-setting" id="offlinePaySetting">
    <second-menu-link-content>
      <template v-slot:header>
        <span>线下支付</span>
      </template>
      <template v-slot:content>
        <section class="content">
          <div class="content-title">银行转账</div>
          <el-button class="btn-blue" @click="addAccount">新增账户</el-button>
          <ul class="bank-account-list">
            <li
              v-for="(bankAccount, index) in bankAccountList"
              :key="index"
              class="bank-card-container"
            >
              <div class="row">
                <span class="bank">{{bankAccount.bankName}}</span>
                <div class="parallelogram">
                  <span class="text en">UnionPay</span>
                  <span class="text ch">银联</span>
                </div>
              </div>
              <div class="row two">
                <div class="bank-card-num">{{bankAccount.type === 1?bankAccount.accountCode:''}}</div>
                <div class="name-btn-container">
                  <span class="name">{{bankAccount.accountName}}</span>
                  <div class="btns">
                    <div @click="editAccount(bankAccount)" class="btn edit-btn"></div>
                    <div @click="deleteAccount(bankAccount)" class="btn delete-btn"></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <el-dialog :title="module ? '编辑账号' : '新增账号'" :visible.sync="showAccountDialog">
            <el-form :model="account" :rules="accountRules" ref="accountForm">
              <el-form-item label="账号名称：" label-width="100px" prop="name">
                <el-input class="gray" v-model="account.name"></el-input>
              </el-form-item>
              <el-form-item label="开户银行：" label-width="100px" prop="bank">
                <el-input class="gray" v-model="account.bank"></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" label-width="100px" prop="bankAccount">
                <el-input class="gray" v-model="account.bankAccount"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="resetForm">取 消</el-button>
              <el-button type="primary" @click="addOrUpdateAccount">确 定</el-button>
            </div>
          </el-dialog>
        </section>
        <section class="content">
          <div class="content-title">支付宝转账</div>
          <div class="images">
            <el-upload
              id="alipayUpload"
              ref="upload"
              action="#"
              :class="alipayImage.length < 1 ? '' : 'none'"
              list-type="picture-card"
              :limit="1"
              :on-exceed="handSaleleLimit"
              :on-remove="onSaleRemove"
              :before-upload="beforeSaleUpload"
              :auto-upload="true"
              :file-list="alipayFileList"
            >
              <el-button
                v-loading="alipayLoading"
                element-loading-text="图片上传中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                slot="trigger"
                size="small"
                type="primary"
              >
                <i class="add">＋</i>
              </el-button>
              <div slot="tip" class="el-upload__tip">建议图片尺寸150*234且不超过2M，支持JPG/JPEG/BMP/PNG格式文件（最多上传一张）</div>
            </el-upload>
          </div>
        </section>
        <section class="content weChat-info">
          <div class="content-title">微信转账</div>
          <div class="images">
            <el-upload
              ref="upload"
              action="#"
              :class="weChatImage.length < 1 ? '' : 'none'"
              list-type="picture-card"
              :limit="1"
              :on-exceed="handSaleleLimit"
              :on-remove="onWeChatRemove"
              :before-upload="beforeWeChatUpload"
              :auto-upload="true"
              :file-list="weChatFileList"
            >
              <el-button
                v-loading="weChatLoading"
                element-loading-text="图片上传中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                slot="trigger"
                size="small"
                type="primary"
              >
                <i class="add">＋</i>
              </el-button>
              <div slot="tip" class="el-upload__tip">建议图片尺寸150*234且不超过2M，支持JPG/JPEG/BMP/PNG格式文件（最多上传一张）</div>
            </el-upload>
          </div>
        </section>
        <section class="content orther-info">
          <div class="content-title">其他转账</div>
          <div class="images">
            <el-upload
              ref="upload"
              action="#"
              :class="ortherImages.length < 5 ?'':'none'"
              list-type="picture-card"
              :limit="5"
              :on-exceed="handleLimit"
              :on-remove="onRemove"
              :before-upload="beforeUpload"
              :auto-upload="true"
              :file-list="ortherFileList"
            >
              <el-button
                v-loading="loading"
                element-loading-text="图片上传中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                slot="trigger"
                size="small"
                type="primary"
              >
                <i class="add">＋</i>
              </el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >建议图片尺寸150*234且不超过2M，支持JPG/JPEG/BMP/PNG格式文件（最多上传5张）</div>
            </el-upload>
          </div>
        </section>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBSiteSet from 'models/db/site-set.js';
import ImgUploader from "models/img-upload.js";
const imgUploader = new ImgUploader();
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    var checkBankAccount = (rule, value, callback) => {
      var pattern = /^[0-9]{10,20}$/;
      console.log(pattern.test(value));
      if (!pattern.test(value)) {
        callback(new Error('请输入有效的银行卡账号'));
      }
      callback();
    };
    return {
      // module 0--新增账户 1--更新账户
      module: 0,
      showAccountDialog: false,
      currentEditedBankAccountId: 0,
      bankAccountList: [],
      account: {
        name: '',
        bank: '',
        bankAccount: ''
      },
      accountRules: {
        name: {
          required: true,
          message: '账号名称不能为空',
          trigger: true
        },
        bank: {
          required: true,
          message: '开户银行不能为空',
          trigger: true
        },
        bankAccount: [
          {
            required: true,
            message: '银行账号不能为空',
            trigger: true
          },
          {
            validator: checkBankAccount,
            trigger: 'blur'
          }
        ]
      },
      alipayFileList: [], // 上传支付宝图片的中间过渡图片数据
      alipayImage: [], //支付宝图片
      alipayLoading: false, // loading开关控制
      saleFile: "", // 支付宝图片上传
      weChatImage: [], //微信图片
      weChatFileList: [], // 上传微信图片的中间过渡图片数据
      weChatLoading: false, // loading开关控制
      weChatFile: "", // 微信图片上传
      ortherFileList: [],
      loading: false,
      ortherImages: [],
    };
  },
  watch: {
    showAccountDialog: {
      handler(newVal) {
        if (!newVal) {
          this.account = {
            name: '',
            bank: '',
            bankAccount: ''
          };
        }
      }
    }
  },
  methods: {
    // 新增账号
    addAccount() {
      this.module = 0;
      this._showAccountFormDialog();
    },
    editAccount(bankAccount) {
      // 编辑账号
      this.module = 1;
      this.currentEditedBankAccountId = bankAccount.id;
      this.account = {
        name: bankAccount.accountName,
        bank: bankAccount.bankName,
        bankAccount: bankAccount.accountCode
      };
      this._showAccountFormDialog();
    },
    deleteAccount(bankAccount) {
      this.$confirm('您的操作将删除改账号', '操作提示', {
        confirmButtonText: '删除账号',
        cancelButtonText: '保留账号',
        type: 'warning'
      })
        .then(() => {
          let id = bankAccount.id;
          this._deleteDBSiteOfflineBankAccountById(id);
        })
        .catch(action => {
          if (action === 'cancel') {
          }
        });
    },
    addOrUpdateAccount(formName) {
      this.$refs.accountForm.validate(valid => {
        if (valid) {
          let data;
          if (!this.module) {
            // 新增
            data = {
              accountName: this.account.name,
              bankName: this.account.bank,
              accountCode: this.account.bankAccount,
              type: 1
            };
            this._addDBSiteOfflineBankAccount(data);
          } else {
            // 编辑
            data = {
              id: this.currentEditedBankAccountId,
              accountName: this.account.name,
              bankName: this.account.bank,
              accountCode: this.account.bankAccount
            };
            this._updateDBSiteOfflineBankAccount(data);
          }
          this._hideAccountFormDialog();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.accountForm.resetFields();
      this._hideAccountFormDialog();
    },
    _showAccountFormDialog() {
      this.showAccountDialog = true;
    },
    _hideAccountFormDialog() {
      this.showAccountDialog = false;
    },
    _getDBSiteOfflineBankAccountList() {
      dbSiteSet
        .getDBSiteOfflineBankAccountList()
        .then(res => {
          if (res.success) {
            this.alipayImage = []
            this.alipayFileList = []
            this.weChatImage = []
            this.weChatFileList = []
            this.ortherImages = []
            this.ortherFileList = []
            this.bankAccountList = []
            res.result.map(i => {
              if (i.type === 1) {
                this.bankAccountList.push(i);
              }
              if (i.type === 2) {
                this.alipayImage = [i];
              }
              if (i.type === 3) {
                this.weChatImage = [i];
              }
              if (i.type === 4) {
                this.ortherImages.push(i);
              }
            })
            this.alipayImage.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.url = value.accountCode;
              this.alipayFileList.push(obj);
            });
            this.weChatImage.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.url = value.accountCode;
              this.weChatFileList.push(obj);
            });
            this.ortherImages.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.url = value.accountCode;
              this.ortherFileList.push(obj);
            });
          }
        })
        .catch(e => {
          console.log('银行卡列表异常--', e);
        });
    },
    _addDBSiteOfflineBankAccount(data) {
      dbSiteSet
        .addDBSiteOfflineBankAccount(data)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              center: true,
              message: '添加成功！',
              duration: 2000
            });
            this._getDBSiteOfflineBankAccountList();
          } else {
            this.$message({
              type: 'error',
              center: true,
              message: res.message,
              duration: 2000
            });
          }
        })
        .catch(e => {
          this.$message({
            type: 'error',
            center: true,
            message: '添加失败，请重试！',
            duration: 2000
          });
        });
    },
    _updateDBSiteOfflineBankAccount(data) {
      dbSiteSet
        .updateDBSiteOfflineBankAccount(data)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              center: true,
              message: '修改成功！',
              duration: 2000
            });
            this._getDBSiteOfflineBankAccountList();
          } else {
            this.$message({
              type: 'error',
              center: true,
              message: res.message,
              duration: 2000
            });
          }
        })
        .catch(e => {
          this.$message({
            type: 'error',
            center: true,
            message: '修改失败，请重试！',
            duration: 2000
          });
        });
    },
    _deleteDBSiteOfflineBankAccountById(id) {
      dbSiteSet
        .deleteDBSiteOfflineBankAccountById(id)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              center: true,
              message: '删除成功！',
              duration: 2000
            });
            this._getDBSiteOfflineBankAccountList();
          } else {
            this.$message({
              type: 'error',
              center: true,
              message: res.message,
              duration: 2000
            });
          }
        })
        .catch(e => {
          this.$message({
            type: 'error',
            center: true,
            message: '删除失败，请重试！',
            duration: 2000
          });
        });
    },
    // 以下为支付宝图片数量大于1
    handSaleleLimit() {
      this.$message({
        message: "图片数量最多1张",
        type: "warning",
      });
    },
    // 删除支付宝图片
    onSaleRemove(file, fileList) {
      this.alipayFileList = fileList;
      this.alipayImage = [];
      this.alipayFileList.map((value, index, Array) => {
        this.alipayImage.push(value.url);
      });
      if (file.id) {
        this._deleteDBSiteOfflineBankAccountById(file.id)
      }
    },
    // 上传支付宝图片进行判断图片
    beforeSaleUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      } else {
        this.alipayLoading = true;
        this.saleFile = file;
        imgUploader
          .postImgUpload(this.saleFile)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.alipayFileList.push(obj);
              this.alipayLoading = false;
              this.alipayImage = [];
              this.alipayFileList.map((value, index, Array) => {
                this.alipayImage.push(value.url);
              });
              if (this.alipayImage.length>0) {
                let data = {
                  type: 2,
                  accountCode: this.alipayImage[0]
                };
                this._addDBSiteOfflineBankAccount(data);
              }
            } else {
              this.alipayLoading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.alipayLoading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    //以下为微信上传图片
    // 删除微信图片
    onWeChatRemove(file, fileList) {
      this.weChatFileList = fileList;
      this.weChatImage = [];
      this.weChatFileList.map((value, index, Array) => {
        this.weChatImage.push(value.url);
      });
      if (file.id) {
        this._deleteDBSiteOfflineBankAccountById(file.id)
      }
    },
    // 上传微信图片进行判断图片
    beforeWeChatUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      } else {
        this.weChatLoading = true;
        this.weChatFile = file;
        imgUploader
          .postImgUpload(this.weChatFile)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.weChatFileList.push(obj);
              this.weChatLoading = false;
              this.weChatImage = [];
              this.weChatFileList.map((value, index, Array) => {
                this.weChatImage.push(value.url);
              });
              if (this.weChatImage.length>0) {
                let data = {
                  type: 3,
                  accountCode: this.weChatImage[0]
                };
                this._addDBSiteOfflineBankAccount(data);
              }
            } else {
              this.weChatLoading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.weChatLoading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    // 以下是其他转账图片
    // 其他转账图片数量大于5
    handleLimit() {
      this.$message({
        message: "图片数量最多5张",
        type: "warning",
      });
    },
    // 删除其他转账图片
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.ortherImages = [];
      this.fileList.map((value, index, Array) => {
        this.ortherImages.push(value.url);
      });
      if (file.id) {
        this._deleteDBSiteOfflineBankAccountById(file.id)
      }
    },
    // 上传其他转账图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.ortherFileList.push(obj);
              this.loading = false;
              this.ortherImages = [];
              this.ortherFileList.map((value, index, Array) => {
                this.ortherImages.push(value.url);
              });
              if (res.imgUrl) {
                let data = {
                  type: 4,
                  accountCode: res.imgUrl
                };
                this._addDBSiteOfflineBankAccount(data);
              }
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
  },
  created() {
    this._getDBSiteOfflineBankAccountList();
  },
  components: {
    SecondMenuLinkContent
  }
};
</script>

<style lang="scss" scoped>
.offline-pay-setting {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  .bank-account-list {
    margin-top: 16px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .bank-card-container {
      box-sizing: border-box;
      margin-right: 20px;
      margin-bottom: 20px;
      width: 320px;
      height: 160px;
      color: rgba(255, 255, 255, 1);
      display: flex;
      flex-direction: column;
      padding-left: 24px;
      padding-right: 16px;
      background: linear-gradient(
        317deg,
        rgba(61, 116, 242, 1) 0%,
        rgba(60, 142, 234, 1) 100%
      );
      border-radius: 8px;
      .row {
        height: 50%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .parallelogram {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 68px;
          height: 36px;
          background: #fff;
          transform: skewX(-20deg);
          border-radius: 4px;
          .text {
            font-size: 12px;
            color: rgba(61, 116, 242, 1);
            font-weight: 550;
          }
        }
      }
      .two {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .bank-card-num {
          font-size: 24px;
        }
        .name-btn-container {
          margin-top: 8px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .btns {
            display: flex;
            .btn {
              width: 16px;
              height: 16px;
              padding: 2px;
              background-size: 16px 16px;
              background-position: center;
              background-repeat: no-repeat;
              cursor: pointer;
            }
            .edit-btn {
              margin-right: 12px;
              background-image: url("../../../../assets/offline-pay/edit.png");
            }
            .delete-btn {
              background-image: url("../../../../assets/offline-pay/delete.png");
            }
          }
        }
      }
    }
  }
  .content {
    box-sizing: border-box;
    .content-title {
      box-sizing: border-box;
      width: 100%;
      height: 32px;
      padding-left: 6px;
      line-height: 32px;
      font-size: 16px;
      font-weight: 550;
      color: #333333;
      margin-bottom: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px 4px 0px 0px;
    }
  }
  .weChat-info,
  .orther-info {
    padding-top: 26px;
  }
  .orther-info {
    padding-bottom: 50px;
  }
}
</style>

<style lang="scss">
#offlinePaySetting {
  .el-input {
    .el-input__inner {
      width: 300px;
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 420px;
      .el-dialog__header {
        box-sizing: border-box;
        width: 100%;
        .el-dialog__title {
          font-weight: 550;
        }
      }
      .el-dialog__body {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .el-dialog__footer {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: space-around;
      }
    }
  }
  .images {
    height: auto;
    margin-bottom: 0;
    .el-upload-list {
      .el-upload-list__item {
        width: 150px;
        height: 234px;
        margin-top: 0px;
      }
    }
    .el-upload--picture-card {
      width: 128px;
      height: 128px;
      border: 0px;
      line-height: 0px;
      .el-upload-list__item-thumbnail {
        height: 128px;
      }
    }
    .authorize {
      .el-upload-list__item-delete {
        display: none;
      }
    }
    .none {
      .el-upload--picture-card {
        display: none;
      }
    }
    .el-button {
      width: 128px;
      height: 128px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 8px;
      border: 1px solid rgba(234, 238, 245, 1);
      > span {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .add {
          width: 22px;
          height: 22px;
          line-height: 22px;
          color: #3d74f2;
          margin-bottom: 10px;
          border: 2px solid #3d74f2;
          border-radius: 50%;
          font-size: 22px;
        }
      }
    }
    .el-upload__tip {
      margin: 0;
      color: rgba(192, 196, 204, 1);
      line-height: 20px;
      margin-left: 16px;
      display: inline-block;
      vertical-align:bottom;
    }
    ul {
      width: 320px;
    }
  }
}
</style>
